module.exports = __webpack_public_path__ + "static/img/cruelty_child.1accd8c1.png";